export default {
  addCarInsuranceInquiry:
    "/gateway/partyH5App/carMinister/carInsuranceInquirycs/addCarInsuranceInquiry", // 提交询价
};



// WEBPACK FOOTER //
// ./src/vehicleInquiry/inputPage/api.js